"use strict";
// import { Context, Next } from 'koa'
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESTErrorBadRequest = exports.RESTErrorConflict = exports.RESTErrorUnauthorized = exports.RESTErrorForbidden = exports.RESTErrorNotFound = exports.RESTError = void 0;
var HTTP_CODES;
(function (HTTP_CODES) {
    HTTP_CODES[HTTP_CODES["ERROR"] = 500] = "ERROR";
    HTTP_CODES[HTTP_CODES["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HTTP_CODES[HTTP_CODES["NOT_FOUND"] = 404] = "NOT_FOUND";
    HTTP_CODES[HTTP_CODES["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HTTP_CODES[HTTP_CODES["FORBIDDEN"] = 403] = "FORBIDDEN";
    HTTP_CODES[HTTP_CODES["METHOD_NOT_ALLOWED"] = 405] = "METHOD_NOT_ALLOWED";
    HTTP_CODES[HTTP_CODES["CONFLICT"] = 409] = "CONFLICT";
})(HTTP_CODES || (HTTP_CODES = {}));
class RESTError extends Error {
    constructor(statusCode = HTTP_CODES.ERROR, name = 'UNKNOWN_ERROR', description, payload, userinfo) {
        super(description || name);
        this.name = name;
        this.statusCode = statusCode;
        this.description = description;
        this.payload = payload;
        this.userinfo = userinfo;
    }
}
exports.RESTError = RESTError;
class RESTErrorNotFound extends RESTError {
    constructor(name = 'NOT_FOUND', description, payload, userinfo) {
        super(HTTP_CODES.NOT_FOUND, name, description, payload, userinfo);
    }
}
exports.RESTErrorNotFound = RESTErrorNotFound;
class RESTErrorForbidden extends RESTError {
    constructor(name = 'FORBIDDEN', description, payload, userinfo) {
        super(HTTP_CODES.FORBIDDEN, name, description, payload, userinfo);
    }
}
exports.RESTErrorForbidden = RESTErrorForbidden;
class RESTErrorUnauthorized extends RESTError {
    constructor(description, payload, userinfo) {
        super(HTTP_CODES.UNAUTHORIZED, 'UNAUTHORIZED', description, payload, userinfo);
    }
}
exports.RESTErrorUnauthorized = RESTErrorUnauthorized;
class RESTErrorConflict extends RESTError {
    constructor(name = 'CONFLICT', description, payload, userinfo) {
        super(HTTP_CODES.CONFLICT, name, description, payload, userinfo);
    }
}
exports.RESTErrorConflict = RESTErrorConflict;
class RESTErrorBadRequest extends RESTError {
    constructor(name = 'BAD_REQUEST', description, payload, userinfo) {
        super(HTTP_CODES.BAD_REQUEST, name, description, payload, userinfo);
    }
}
exports.RESTErrorBadRequest = RESTErrorBadRequest;
